import SEO from '../components/SEO';
import PageLayout from '../components/PageLayout';
import LeadForm from '../components/LeadForm';
import { SITE, FAQS } from '../lib/site';
import { PhoneCall, Clock, FileCheck2, BadgeEuro } from 'lucide-react';

const Presupuesto = () => {
  return (
    <PageLayout
      label="Presupuesto"
      title="Presupuesto gratis"
      titleEm="en 24 horas"
      lead="Visita, medición y presupuesto detallado sin compromiso. En menos de 48 horas laborables tienes cifras reales por escrito, no estimaciones vagas."
      crumbs={[{ name: 'Presupuesto' }]}
    >
      <SEO
        title="Presupuesto Gratis de Reformas y Construcción en Málaga"
        description="Solicita tu presupuesto gratis de reforma o construcción en Málaga. Visita sin compromiso, cifras detalladas en 24-48h y garantía de 10 años por escrito."
        url="/presupuesto"
        breadcrumbs={[{ name: 'Inicio', url: '/' }, { name: 'Presupuesto', url: '/presupuesto' }]}
        faqSchema={FAQS.slice(0, 4)}
      />

      <section className="max-w-[1400px] mx-auto px-6 py-16 md:py-24">
        <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-14 lg:gap-20 items-start">
          {/* Qué incluye */}
          <div>
            <div className="space-y-10">
              {[
                {
                  icon: PhoneCall,
                  title: '1. Contacta por WhatsApp o teléfono',
                  text: 'Cuéntanos qué necesitas: reforma integral, obra nueva, local o mantenimiento. Te preguntamos lo justo para agendar la visita.',
                },
                {
                  icon: Clock,
                  title: '2. Visita y medición real',
                  text: 'Vamos a tu vivienda o local, medimos cada estancia y hablamos de lo que quieres cambiar, con opciones de acabados y su impacto en precio.',
                },
                {
                  icon: FileCheck2,
                  title: '3. Presupuesto cerrado en 24–48h',
                  text: 'Recibes un documento con cada partida desglosada: albañilería, instalaciones, acabados, gestión de residuos y plazos. Lo que firmas es lo que pagas.',
                },
                {
                  icon: BadgeEuro,
                  title: '4. Sin compromiso',
                  text: 'El presupuesto es tuyo. Compáralo, piénsalo y decide. Si no encaja, sin problema: también te asesoramos sin coste sobre qué es razonable pagar.',
                },
              ].map((s, i) => (
                <div key={i} className="reveal flex gap-5">
                  <span className="grid place-items-center w-12 h-12 rounded-full bg-ink text-clay-light shrink-0">
                    <s.icon size={20} />
                  </span>
                  <div>
                    <h2 className="font-display font-bold text-lg tracking-tight uppercase">{s.title}</h2>
                    <p className="mt-2 text-ink-soft leading-relaxed text-[0.95rem]">{s.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="reveal mt-12 bg-paper-2 border border-line rounded-[4px] p-7">
              <h3 className="font-display font-bold uppercase tracking-tight text-base">Preferencias de pago flexibles</h3>
              <p className="mt-3 text-sm text-ink-soft leading-relaxed">
                Trabajamos con pagos ligados a hitos de obra (no por adelantado total).
                Financiación disponible mediante acuerdo. Pregunta en la visita y te
                detallamos las opciones.
              </p>
            </div>

            <div className="reveal mt-8">
              <a href={`tel:${SITE.phone}`} className="btn border border-ink text-ink">
                <PhoneCall size={16} />
                O llámanos: {SITE.phoneDisplay}
              </a>
            </div>
          </div>

          {/* Formulario */}
          <div className="reveal lg:sticky lg:top-28">
            <LeadForm
              title="Empieza tu presupuesto"
              subtitle="Rellena el formulario y te abrimos WhatsApp con tu consulta lista para enviar. Respondemos en menos de 24 horas laborables."
            />
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Presupuesto;
